export default __webpack_public_path__ + "static/media/Savant's Armbands of Twining Smoke.1d5bdbab.jpg";